export function setCoverDocuments(state, action) {
  let selectedPolicy = state.selectedPolicy;
  let policyDetails = null;

  if (state.policyDetails) {
    policyDetails = Object.assign({}, state.policyDetails, {
      Policies:
        state.policyDetails &&
        state.policyDetails.Policies &&
        state.policyDetails.Policies.map((policy) => {
          if (policy.MembershipNumber === action.payload.MembershipNumber) {
            let newPolicy = Object.assign({}, policy);
            if (action.payload.MembershipStatement !== undefined) {
              newPolicy.MembershipStatement =
                action.payload.MembershipStatement;
            }
            if (action.payload.TravelDocuments) {
              newPolicy.TravelDocuments = action.payload.TravelDocuments;
            }
            if (action.payload.EnclosureDocuments) {
              newPolicy.EnclosureDocuments = action.payload.EnclosureDocuments;
            }

            if (selectedPolicy === policy) {
              selectedPolicy = newPolicy;
            }
            return newPolicy;
          }
          return policy;
        })
    });
  }

  return {
    policyDetails,
    selectedPolicy
  };
}

export function setRenewalDocuments(state, action) {
  let selectedPolicy = state.selectedPolicy;
  let policyDetails = null;

  if (state.policyDetails) {
    policyDetails = Object.assign({}, state.policyDetails, {
      Policies:
        state.policyDetails &&
        state.policyDetails.Policies &&
        state.policyDetails.Policies.map((policy) => {
          if (policy.MembershipNumber === action.payload.MembershipNumber) {
            let newPolicy = Object.assign({}, policy);
            if (action.payload.MembershipStatement !== undefined) {
              newPolicy.RenewalMembershipStatement =
                action.payload.MembershipStatement;
            }
            if (action.payload.TravelDocuments) {
              newPolicy.RenewalTravelDocuments = action.payload.TravelDocuments;
            }
            if (action.payload.EnclosureDocuments) {
              newPolicy.RenewalEnclosureDocuments =
                action.payload.EnclosureDocuments;
            }

            if (selectedPolicy === policy) {
              selectedPolicy = newPolicy;
            }
            return newPolicy;
          }
          return policy;
        })
    });
  }

  return {
    policyDetails,
    selectedPolicy
  };
}
